import {ApiResponse, defaultFetch, httpMethod, responseType} from "@/scripts/Common/api";
import {getToken} from "@/scripts/Common";
import {Reports} from "@/components/reports/scripts/types";


const fetchReport = async (
  apiName: Reports,
  language: string,
  queries?: Record<string, string | number | undefined | null | boolean | any[]>,
  routeParams?: Record<string, string>
): Promise<ApiResponse<string>> => await defaultFetch({
  apiName,
  options: {
    method: httpMethod.GET,
    query: queries,
    routeParams: routeParams,
    headers: {
      'Content-Type': 'application/text',
      'Accept-Language': language
    }
  },
  resultType: responseType.text,
  bearer: getToken()
});

export {
  fetchReport,
}
